<template>
  <div class="row">
    <div class="col-3">
      <Search :onResponse="onResponse" />
    </div>
    <div class="col-9">
      <Chart :chartdata="prediction" v-if="shouldShowChart" />
      <div class="chart-placeholder" v-else>
        Select parameters for price prediction.
      </div>
      <Table :items="predictionArray" v-if="shouldShowChart" name="Year" />
    </div>
  </div>
</template>

<script>
import Search from "../../components/prediction/Year/Search";
import Chart from "../../components/Chart";
import Table from "../../components/prediction/Table";

export default {
  components: {
    Search,
    Chart,
    Table
  },
  data() {
    return {
      prediction: {},
    };
  },
  methods: {
    onResponse(data) {
      this.prediction = data;
    }
  },
  computed: {
    shouldShowChart() {
      return Object.keys(this.prediction).length;
    },
    predictionArray() {
      return Object.keys(this.prediction).map(key => {
        return {
          name: key,
          price: this.prediction[key]
        }
      });
    }
  }
};
</script>

<style></style>
